import React from "react";
import { Button } from "reactstrap";
import {
  buildSubscriptionSummaryFields,
  getSubscriptionCancelMessage,
  splitPriceDisplay,
} from "./planUtils";
import SubscriptionAllowancesPanel from "./subscriptionAllowancesPanel";

const CurrentSubscriptionDetails = ({
  subscription,
  user = null,
  onManageBilling,
  billingInProgress = false,
  showAllowances = true,
}) => {
  if (!subscription?.plan_name) {
    return null;
  }

  const cancelMessage = getSubscriptionCancelMessage(subscription);
  const summaryFields = buildSubscriptionSummaryFields(subscription);
  const { amount, interval } = splitPriceDisplay(subscription.price_display || "—");
  const priceValue = subscription.price_display
    || (amount !== "—" ? `${amount}${interval ? ` ${interval}` : ""}` : "");

  const planFields = [
    { label: "Plan name", value: subscription.plan_name },
    ...(priceValue ? [{ label: "Price", value: priceValue }] : []),
  ];

  const overviewFields = [...planFields, ...summaryFields];

  return (
    <div className="stripe-subscription-overview">
      <div className="stripe-subscription-overview-main">
        {overviewFields.length > 0 && (
          <div className="stripe-subscription-overview-fields">
            {overviewFields.map((field) => (
              <div key={field.label} className="stripe-subscription-overview-field">
                <span className="stripe-subscription-overview-field-label">{field.label}</span>
                <span
                  className={`stripe-subscription-overview-field-value${
                    field.label === "Plan name" ? " is-plan-name" : ""
                  }`}
                >
                  {field.value}
                </span>
              </div>
            ))}
          </div>
        )}

        {onManageBilling && (
          <div className="stripe-subscription-overview-action">
            <Button
              color="primary"
              className="stripe-subscription-overview-manage-btn"
              disabled={billingInProgress}
              onClick={onManageBilling}
            >
              {billingInProgress ? "Opening..." : "Manage billing"}
            </Button>
          </div>
        )}
      </div>

      {showAllowances && user && (
        <SubscriptionAllowancesPanel user={user} subscription={subscription} />
      )}

      {cancelMessage && (
        <p className="stripe-subscription-overview-notice">{cancelMessage}</p>
      )}
    </div>
  );
};

export default CurrentSubscriptionDetails;
